/**
 * Footer payment icons: tap-to-enlarge on touch devices (same scale as desktop hover).
 */
(function () {
  'use strict';

  var ROOT = '.footer-payment-icons';
  var ITEM = '.footer-payment-icons__item';
  var TRIGGER = '.footer-payment-icons__trigger';
  var ENLARGED = 'is-enlarged';
  var INIT = 'paymentIconsInit';
  var touchMq = window.matchMedia('(hover: none), (pointer: coarse)');

  function clearEnlarged(root) {
    root.querySelectorAll(ITEM + '.' + ENLARGED).forEach(function (item) {
      item.classList.remove(ENLARGED);
    });
  }

  function init(root) {
    if (root.dataset[INIT]) {
      return;
    }
    root.dataset[INIT] = 'true';

    root.addEventListener('click', function (event) {
      if (!touchMq.matches) {
        return;
      }

      var trigger = event.target.closest(TRIGGER);
      if (!trigger || !root.contains(trigger)) {
        return;
      }

      var item = trigger.closest(ITEM);
      var wasEnlarged = item.classList.contains(ENLARGED);

      clearEnlarged(root);

      if (!wasEnlarged) {
        item.classList.add(ENLARGED);
      }
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  document.addEventListener('click', function (event) {
    if (!touchMq.matches) {
      return;
    }

    document.querySelectorAll(ROOT).forEach(function (root) {
      if (root.contains(event.target)) {
        return;
      }
      clearEnlarged(root);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
